/**
 * Carrusel Grid 4x2 — flechas de navegación.
 *
 * Extraído del <script> inline de sections/cuadriculas-collecciones.liquid para que
 * se cachee en vez de viajar con cada respuesta HTML.
 *
 * La lógica de scroll es idéntica a la original. Cambios en el arranque:
 * descubre las secciones por sí mismo en vez de recibir un section.id interpolado,
 * y responde a shopify:section:load (antes las flechas quedaban muertas al recargar
 * la sección desde el editor de temas).
 */
(function () {
  // Cada instancia de la sección emite su propio <script src>; sin esta guarda el
  // archivo se ejecutaría una vez por instancia.
  if (window.__cuadriculasColeccionesLoaded) return;
  window.__cuadriculasColeccionesLoaded = true;

  function initSection(section) {
    if (!section || section.dataset.sectorsInit === 'true') return;

    var sectionId = section.id.replace('SectorsSection-', '');
    var track = document.getElementById('Track-' + sectionId);
    var prevBtn = document.getElementById('Prev-' + sectionId);
    var nextBtn = document.getElementById('Next-' + sectionId);

    if (!track || !prevBtn || !nextBtn) return;
    section.dataset.sectorsInit = 'true';

    var getScrollAmount = function () {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap) || 22;
      return track.clientWidth + gap;
    };

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="SectorsSection-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(document.getElementById('SectorsSection-' + event.detail.sectionId));
  });
})();
